import {
  FETCH_LOCATIONS,
  SCAN_ITEM,
  FETCH_STOCK_LEVELS,
  FETCH_STOCK_ITEMS,
  PROCESS_SHIPMENT,
  FETCH_ALERTS,
  RESOLVE_ALERT,
  CHECK_EXPIRING,
  FETCH_CONSUMPTION_HISTORY,
  FETCH_CONSUMPTION_REPORT,
  GENERATE_DAILY_SUMMARY,
  ADJUST_STOCK,
  SET_FIFO_WARNING,
  CLEAR_FIFO_WARNING,
  SET_SCAN_MODE,
  CLEAR_SCAN_RESULT,
} from "./types";
import * as API from "./api";

// --------------------------------------------------------------------------
// FETCH_LOCATIONS
// --------------------------------------------------------------------------
export const fetchLocations = () => ({
  type: FETCH_LOCATIONS.init,
  payload: API.fetchLocations(),
});

export const fetchLocationsSuccess = (info) => ({
  type: FETCH_LOCATIONS.success,
  payload: info,
});

export const fetchLocationsFailure = (error) => ({
  type: FETCH_LOCATIONS.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// SCAN_ITEM
// --------------------------------------------------------------------------
export const scanItem = (barcode, locationId, quantity, purpose = "REGULAR_USE", notes = "") => ({
  type: SCAN_ITEM.init,
  payload: API.scanItem({ barcode, location_id: locationId, quantity, purpose, notes }),
});

export const scanItemInit = () => ({
  type: SCAN_ITEM.init,
});

export const scanItemSuccess = (info) => ({
  type: SCAN_ITEM.success,
  payload: info,
});

export const scanItemFailure = (error) => ({
  type: SCAN_ITEM.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_STOCK_LEVELS
// --------------------------------------------------------------------------
export const fetchStockLevels = (locationId, lowStockOnly = false) => ({
  type: FETCH_STOCK_LEVELS.init,
  payload: API.fetchStockLevels(locationId, lowStockOnly),
});

export const fetchStockLevelsSuccess = (info) => ({
  type: FETCH_STOCK_LEVELS.success,
  payload: info,
});

export const fetchStockLevelsFailure = (error) => ({
  type: FETCH_STOCK_LEVELS.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_STOCK_ITEMS
// --------------------------------------------------------------------------
export const fetchStockItems = (locationId, itemId, barcode, isActive, page) => ({
  type: FETCH_STOCK_ITEMS.init,
  payload: API.fetchStockItems(locationId, itemId, barcode, isActive, page),
});

export const fetchStockItemsSuccess = (info) => ({
  type: FETCH_STOCK_ITEMS.success,
  payload: info,
});

export const fetchStockItemsFailure = (error) => ({
  type: FETCH_STOCK_ITEMS.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// PROCESS_SHIPMENT
// --------------------------------------------------------------------------
export const processShipment = (shipmentReportId) => ({
  type: PROCESS_SHIPMENT.init,
  payload: API.processShipment(shipmentReportId),
});

export const processShipmentSuccess = (info) => ({
  type: PROCESS_SHIPMENT.success,
  payload: info,
});

export const processShipmentFailure = (error) => ({
  type: PROCESS_SHIPMENT.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_ALERTS
// --------------------------------------------------------------------------
export const fetchAlerts = (locationId, alertType, activeOnly = true) => ({
  type: FETCH_ALERTS.init,
  payload: API.fetchAlerts(locationId, alertType, activeOnly),
});

export const fetchAlertsSuccess = (info) => ({
  type: FETCH_ALERTS.success,
  payload: info,
});

export const fetchAlertsFailure = (error) => ({
  type: FETCH_ALERTS.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// RESOLVE_ALERT
// --------------------------------------------------------------------------
export const resolveAlert = (alertId) => ({
  type: RESOLVE_ALERT.init,
  payload: API.resolveAlert(alertId),
});

export const resolveAlertSuccess = (info) => ({
  type: RESOLVE_ALERT.success,
  payload: info,
});

export const resolveAlertFailure = (error) => ({
  type: RESOLVE_ALERT.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// CHECK_EXPIRING
// --------------------------------------------------------------------------
export const checkExpiring = (locationId, daysAhead = 7) => ({
  type: CHECK_EXPIRING.init,
  payload: API.checkExpiringItems(locationId, daysAhead),
});

export const checkExpiringSuccess = (info) => ({
  type: CHECK_EXPIRING.success,
  payload: info,
});

export const checkExpiringFailure = (error) => ({
  type: CHECK_EXPIRING.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_CONSUMPTION_HISTORY
// --------------------------------------------------------------------------
export const fetchConsumptionHistory = (locationId, fromDate, toDate) => ({
  type: FETCH_CONSUMPTION_HISTORY.init,
  payload: API.fetchConsumptionHistory(locationId, fromDate, toDate),
});

export const fetchConsumptionHistorySuccess = (info) => ({
  type: FETCH_CONSUMPTION_HISTORY.success,
  payload: info,
});

export const fetchConsumptionHistoryFailure = (error) => ({
  type: FETCH_CONSUMPTION_HISTORY.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_CONSUMPTION_REPORT
// --------------------------------------------------------------------------
export const fetchConsumptionReport = (locationId, groupBy, fromDate, toDate, itemId) => ({
  type: FETCH_CONSUMPTION_REPORT.init,
  payload: API.fetchConsumptionReport(locationId, groupBy, fromDate, toDate, itemId),
});

export const fetchConsumptionReportSuccess = (info) => ({
  type: FETCH_CONSUMPTION_REPORT.success,
  payload: info,
});

export const fetchConsumptionReportFailure = (error) => ({
  type: FETCH_CONSUMPTION_REPORT.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// GENERATE_DAILY_SUMMARY
// --------------------------------------------------------------------------
export const generateDailySummary = (locationId, date) => ({
  type: GENERATE_DAILY_SUMMARY.init,
  payload: API.generateDailySummary(locationId, date),
});

export const generateDailySummarySuccess = (info) => ({
  type: GENERATE_DAILY_SUMMARY.success,
  payload: info,
});

export const generateDailySummaryFailure = (error) => ({
  type: GENERATE_DAILY_SUMMARY.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// ADJUST_STOCK
// --------------------------------------------------------------------------
export const adjustStock = (locationId, itemId, quantity, reason) => ({
  type: ADJUST_STOCK.init,
  payload: API.adjustStock({ location_id: locationId, item_id: itemId, quantity, reason }),
});

export const adjustStockSuccess = (info) => ({
  type: ADJUST_STOCK.success,
  payload: info,
});

export const adjustStockFailure = (error) => ({
  type: ADJUST_STOCK.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// UI STATE ACTIONS
// --------------------------------------------------------------------------
export const setFifoWarning = (warning) => ({
  type: SET_FIFO_WARNING,
  payload: warning,
});

export const clearFifoWarning = () => ({
  type: CLEAR_FIFO_WARNING,
});

export const setScanMode = (mode) => ({
  type: SET_SCAN_MODE,
  payload: mode,
});

export const clearScanResult = () => ({
  type: CLEAR_SCAN_RESULT,
});